import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/meetingAgenda/list'
import oneMeetingAgendaReducer, { oneMeetingAgendaActions } from '@app-store/slices/meetingAgenda/oneMeeting'

export const meetingAgendaReducer = combineReducers({
    list: listReducer,
    oneMeeting: oneMeetingAgendaReducer
})

export const meetingAgendaActions = {
    list: listActions,
    oneMeeting: oneMeetingAgendaActions
}
